import React from "react";

const CannotFound = () => {
  return (
    <div>
      <h1 style={{ textAlign: "center", marginTop: 200 }}>
        The page cannot be found:(
      </h1>
    </div>
  );
};

export default CannotFound;
